<!-- 崇峰定制打印销售单 -->
<template>
    <div v-loading="loading">
        <div id="printContent" class="print-zone">
            <div class="print-for" v-bind:key="item.EntpCusOId" v-for="item in printList">
                <div class="print-title-view">
                    <div class="order-code">
                        <canvas id="canvas" class="qrcode-canvas" ref="canva"></canvas>
                        <img class="qrcode-image" :src="imgUrl" v-if="imgUrl" />
                    </div>

                    <div class="print-title">销售出库单</div>

                    <div class="order-detail">
                        <div class="right">单号：{{ item.OrderCode }}</div>
                        <div class="right">
                            日期：
                            <el-date-picker
                                v-show="isEditOpenTime"
                                v-model="item.CreateTime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                type="datetime"
                                size="small"
                                placeholder="选择日期时间"
                            ></el-date-picker>
                            <span v-show="!isEditOpenTime">{{ item.CreateTime }}</span>
                        </div>
                    </div>
                </div>
                <div class="print-table-main">
                    <div class="div-table-row">
                        <div class="div-table-cell" style="width: 20%">客户名称</div>
                        <div class="div-table-cell fdzt" style="width: 80%">
                            {{ item.EntpCusName }}
                        </div>
                    </div>
                    <el-table :data="tableData" border class="fkyou" header-row-class-name="fkyou" style="width: 100%">
                        <el-table-column label="序号" width="38px" sortable type="index"> </el-table-column>
                        <el-table-column prop="GoodCode" width="76px" label="UNP码">
                            <template slot-scope="scope">
                                {{ (scope.row.GoodCode || '').split(',')[0] }}
                            </template>
                        </el-table-column>
                        <el-table-column width="128px" prop="APCode" show-overflow-tooltip label="汽配编码"></el-table-column>
                        <el-table-column width="163px" prop="GoodName" show-overflow-tooltip label="配件名称"> </el-table-column>
                        <el-table-column width="114px" prop="AutoSerise" show-overflow-tooltip label="车型"> </el-table-column>
                        <el-table-column align="center" width="80px" label="已出库数">
                            <template slot-scope="scope">
                                {{ scope.row.Count + scope.row.Unit }}
                            </template>
                        </el-table-column>
                        <el-table-column align="center" prop="Price" width="90px" label="售价"> </el-table-column>
                        <el-table-column align="center" width="101px" label="金额">
                            <template slot-scope="scope">
                                {{ (scope.row.Count * scope.row.Price).toFixed(2) }}
                            </template>
                        </el-table-column>
                        <!-- <el-table-column align="center" prop="GoodsLocation" width="67px" label="仓位">
            </el-table-column> -->
                    </el-table>
                    <div class="div-table-row-bottom">
                        <div class="" style="width: 15%">合计：</div>
                        <div class="" style="width: 6%">
                            {{ allNum }}
                        </div>
                        <div class="" style="width: 28%">￥{{ allPrice }}</div>
                    </div>
                </div>
                <el-row type="flex" class="order-remark">
                    <el-col v-if="item.ShipAmount > 0" :span="6">运费：{{ item.ShipAmount }}</el-col>
                    <el-col v-else :span="6"></el-col>
                    <el-col v-if="item.DiscountAmount > 0" :span="6">优惠金额：-{{ item.DiscountAmount }}</el-col>
                    <el-col v-else :span="6"></el-col>
                    <el-col :span="6">实收金额：￥{{ (allPrice - item.DiscountAmount).toFixed(2) }}</el-col>
                    <el-col :span="6"></el-col>
                </el-row>
                <el-row type="flex" class="order-remark">
                    <el-col :span="12">备注：{{ item.Remark }}</el-col>
                    <el-col :span="12">人民币大写：{{ capitalAmount }}</el-col>
                </el-row>
                <el-row type="flex" class="order-remark">
                    <el-col :span="6">支付方式：{{ item.PayTypeName }}</el-col>
                    <el-col :span="6">发货方式：{{ item.ShipTypeName }}</el-col>
                    <el-col :span="6"> 业务员：{{ nameConfig ? (item.SNickName ? item.SNickName : item.SName) : item.SName }}</el-col>
                    <el-col :span="6">备货员：</el-col>
                </el-row>
                <!--    脚注    -->
                <div class="order-remark" v-if="config == null ? false : config.Result && !isEditConfig">
                    {{ config.RValue }}
                </div>
                <div class="order-setcontent" v-if="isEditConfig">
                    <el-input type="textarea" resize="auto" rows="3" v-model="config.RValue"></el-input>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <div class="btn-ctn-left">
                <!--   脚注   -->
                <div class="re-set">
                    <el-button class="btn-primary" @click="setConfig()" v-if="config == null ? false : config.Result && !isEditConfig">编辑脚注</el-button>
                    <el-button class="btn-primary" @click="submitConfig()" v-if="isEditConfig">保存脚注</el-button>
                </div>
                <!--   开单时间   -->
                <div class="open-time">
                    <el-button class="btn-primary" @click="setOpenTime()" v-if="openTimeConfig && openTimeConfig.Result && !isEditOpenTime">设置开单时间</el-button>
                    <el-button class="btn-primary" @click="submitOpenTime()" v-if="isEditOpenTime">保存开单时间</el-button>
                </div>
                <div class="sort-set">
                    <el-button class="btn-primary" @click="setSortField('sortnum')">原始排序</el-button>
                    <el-button class="btn-primary" @click="setSortField('code')">编码排序</el-button>
                    <!-- <el-button class="btn-primary"  @click="setSortField('shelfspace')">仓位排序</el-button> -->
                </div>
            </div>
            <div class="re-submit">
                <el-button class="btn-primary" @click="printedRecord" v-print="'#printContent'">打印</el-button>
                <el-button @click="cancel()">关闭</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import html2canvas from 'html2canvas';
// import JsBarcode from "jsbarcode";
import QRCode from 'qrcode';
export default {
    name: '',
    components: {},
    props: ['printId', 'printType', 'recordIds'],
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            loading: false,
            allPrice: 0,
            allNum: 0,
            printList: [],
            company: userMsg.EntpName,
            isEditTitle: false, //编辑标题
            openTimeConfig: null, // 开单时间配置
            isEditOpenTime: false, // 编辑开单时间
            nameConfig: false,
            config: null, // 脚注配置
            isEditConfig: false, // 编辑脚注
            capitalAmount: '',
            imgUrl: '',
            sortField: 'sortnum', //排序
            orderdata: [],
            tableData: [],
            type: 0
        };
    },
    watch: {
        printList(value) {
            if (this.imgUrl) return;
            this.$nextTick(function () {
                try {
                    let canvas = this.$refs.canva[0];
                    QRCode.toCanvas(
                        canvas,
                        value[0].OrderCode,
                        {
                            width: 80,
                            height: 80,
                            margin: 0,
                            scrollX: 0,
                            scrollY: 0
                        },
                        function (error) {}
                    );

                    setTimeout(() => {
                        html2canvas(canvas, {
                            width: 80,
                            height: 80,
                            scrollX: 0,
                            scrollY: 0
                        }).then(canvasRes => {
                            var imgData = canvasRes.toDataURL('image/png');
                            this.imgUrl = imgData;
                            canvas.style.display = 'none';
                        });
                    }, 1000);
                } catch (e) {
                    //
                }
            });
        }
    },
    mounted() {
        if (this.printType) this.type = +this.printType;
        this.getSaleOrder();
        this.getConfigByCodes();
    },
    methods: {
        getConfigByCodes() {
            let codes = ['dyxssj', 'dyxs', 'dyywync'];
            this.$util.getSysConfigs(codes).then(data => {
                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        let code = data[i].Code;
                        let result = data[i].Result;
                        switch (code) {
                            case 'dyxssj':
                                this.openTimeConfig = data[i];
                                break;
                            case 'dyxs':
                                this.config = data[i];
                                break;
                            case 'dyywync':
                                this.nameConfig = result;
                                break;
                        }
                    }
                }
            });
        },
        printedRecord() {
            this.loading = true;
            this.$util
                .printedRecord(
                    {
                        OrderId: this.printId,
                        Type: 7
                    },
                    true
                )
                .then(res => {
                    this.loading = false;
                });
        },
        // 取消
        cancel() {
            this.$emit('closeDialog');
        },
        // 获取表格数据
        getSaleOrder() {
            this.loading = true;
            if (this.type === 0)
                this.$util
                    .axiosGet({
                        url: '/api/EntpSaleOrder/GetEntpCusSaleOrderOutPrint',
                        data: {
                            EntpCusOId: this.printId,
                            SortField: this.sortField
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        let _allNum = 0;
                        let _allPrice = 0;
                        let data = res.data;
                        this.orderdata = res.data;
                        this.tableData = res.data.DetailList;
                        let DetailList = data.DetailList;
                        for (let i = 0; i < DetailList.length; i++) {
                            _allNum += Number(DetailList[i].Count);
                            _allPrice += DetailList[i].Count * DetailList[i].Price;
                        }
                        this.allNum = _allNum;
                        this.allPrice = _allPrice.toFixed(2);
                        this.printList = [res.data];
                        let total = (_allPrice + Number(data.ShipAmount) - Number(data.DiscountAmount)).toFixed(2);
                        if (total > 0) {
                            this.capitalAmount = this.$util.moneyToCapital(total);
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            else
                this.$util
                    .axiosPost({
                        url: '/api/EntpSaleOrder/PEntpCusSaleOrderOutPrint',
                        data: {
                            OrderId: this.printId,
                            RecordIds: this.recordIds
                        }
                    })
                    .then(res => {
                        let _allNum = 0;
                        let _allPrice = 0;
                        let data = res.data;
                        this.orderdata = res.data;
                        this.tableData = res.data.DetailList;
                        let DetailList = data.DetailList;
                        for (let i = 0; i < DetailList.length; i++) {
                            _allNum += Number(DetailList[i].Count);
                            _allPrice += DetailList[i].Count * DetailList[i].Price;
                        }
                        this.allNum = _allNum;
                        this.allPrice = _allPrice.toFixed(2);
                        this.printList = [res.data];
                        let total = (_allPrice + Number(data.ShipAmount) - Number(data.DiscountAmount)).toFixed(2);
                        if (total > 0) {
                            this.capitalAmount = this.$util.moneyToCapital(total);
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                    });
        },
        setOpenTime() {
            this.isEditOpenTime = true;
        },
        submitOpenTime() {
            this.isEditOpenTime = false;
        },
        setConfig() {
            this.isEditConfig = true;
        },
        // 提交脚注
        submitConfig() {
            if (!this.config.RValue || !this.config.RValue.trim()) {
                this.$message.error('请输入脚注');
                return;
            }
            this.isEditConfig = false;
            this.$util.setSysConfigValue(this.config.ConfigId, this.config.RValue);
        },
        setSortField(field) {
            this.sortField = field;
            this.getSaleOrder();
        }
    }
};
</script>
<style lang="less">
.el-table th {
    padding-right: 0px;
}
.el-table .cell {
    padding-right: 0px;
}
.fkyou {
    border-right: 1px solid #000;
    border-left: 1px solid #000;
    border-bottom: 1px solid #000;
    margin-bottom: 0px;
    font-size: 12px;
}
.fkyou td {
    padding: 0;
    border-right: 1px solid #000;
    border-top: 1px solid #000;
    .cell {
        padding-left: 1px;
        white-space: nowrap;
        overflow: hidden !important;
        text-overflow: clip;
    }
}
.fkyou th {
    padding: 0;
    border: 1px solid #000;
    .cell {
        padding-left: 5px;
    }
    &:first-child .cell {
        padding-left: 5px;
        padding-right: 0;
    }
}

.fkyou div {
    color: #000;
}
</style>
<style lang="less" scoped media="print">
.el-row {
    margin-bottom: 0;
}
.print-title-view {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 12px 0;
    .qrcode-canvas,
    .qrcode-image {
        width: 80px;
        height: 80px;
        display: inline-block;
        vertical-align: top;
    }
}
.order-detail {
    color: #000;
}

.order-remark {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-left: 10px;
    margin-right: 10px;
    padding-top: 5px;
    color: #000;
}
.order-setcontent {
    padding: 0px 0px 15px 0px;
    color: #000;
}
.print-title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 50%;
    margin: 0 auto;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #000;
    min-height: 26px;
}
.dialog-footer {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 20px;
}
.re-submit {
    text-align: right;
}

.print-zone {
    width: 210mm;
    margin-left: 2rpx;
}

.print-table-main {
    width: 792px;
    margin-left: 1px;
    .div-table-cell {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: auto;
        line-height: 30px;
        padding-left: 11px;
        border-top: 1px solid #000;
        border-right: 1px solid #000;
        // border-bottom: 1px solid #000;
        color: #000;
    }
    .div-table-row {
        border-left: 1px solid #000;
        margin: 0;
        font-size: 12px;
    }
    .div-table-row-bottom {
        color: #000;
        line-height: 30px;
        border: 1px solid #000;
        border-top: none;
        display: flex;
        justify-content: flex-end;
        text-align: center;
    }
    .pall-count {
        text-align: right;
    }
}
.btn-ctn-left {
    display: flex;
}
.fullCut {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.fdzt {
    font-size: 14px;
}
.sort-set {
    margin-left: 10px;
    .btn-primary {
        background: #ff9900;
        color: white;
        margin-left: 0px;
    }
}
</style>
